import React, { useState, useEffect } from 'react';

export default function TicketDetailModal({ ticketId, onClose, apiBase='/api/tickets_advanced.php', token }) {
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(false);
  const [comment, setComment] = useState('');
  const [internal, setInternal] = useState(false);

  useEffect(() => {
    if (ticketId) fetchTicket();
  }, [ticketId]);

  async function fetchTicket() {
    setLoading(true);
    try {
      const res = await fetch(`${apiBase}?id=${ticketId}`);
      const j = await res.json();
      setTicket(j.ticket ?? j);
    } catch (e) {
      console.error(e);
    } finally { setLoading(false); }
  }

  async function postComment(e) {
    e.preventDefault();
    if (!comment.trim()) return;
    try {
      const res = await fetch(`${apiBase}?id=${ticketId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': token ? ('Bearer ' + token) : '' },
        body: JSON.stringify({ comments: [...(ticket.comments||[]), { author: 'me', body: comment, internal: internal, created_at: new Date().toISOString() }] })
      });
      const j = await res.json();
      if (!res.ok) throw new Error(j.error || 'Failed');
      setComment('');
      fetchTicket();
    } catch (e) {
      console.error(e);
      alert('Falha ao enviar comentário');
    }
  }

  if (!ticketId) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded w-11/12 md:w-3/4 max-h-[90vh] overflow-auto p-4">
        <div className="flex justify-between items-center mb-3">
          <h3 className="text-lg font-semibold">{ticket ? (ticket.title || ticket.external_id) : 'Carregando...'}</h3>
          <button onClick={onClose} className="px-2 py-1 border rounded">Fechar</button>
        </div>
        {loading ? <div>Carregando...</div> : (
          <>
            <div className="mb-3">
              <strong>Descrição:</strong>
              <div className="whitespace-pre-wrap">{ticket.description}</div>
            </div>
            <div className="mb-3">
              <strong>Comentários:</strong>
              <div className="space-y-2">
                {(ticket.comments || []).map((c, idx) => (
                  <div key={idx} className={`p-2 rounded ${c.internal ? 'bg-yellow-50' : 'bg-gray-50'}`}>
                    <div className="text-sm text-gray-600">{c.author} • {new Date(c.created_at).toLocaleString()}</div>
                    <div>{c.body}</div>
                    {c.internal && <div className="text-xs italic text-red-600">Nota interna</div>}
                  </div>
                ))}
              </div>
            </div>
            <form onSubmit={postComment} className="mt-3">
              <textarea className="w-full p-2 border rounded" rows={4} value={comment} onChange={e=>setComment(e.target.value)} />
              <div className="flex items-center gap-2 mt-2">
                <label className="flex items-center gap-1"><input type="checkbox" checked={internal} onChange={e=>setInternal(e.target.checked)} /> Interno</label>
                <button className="ml-auto px-3 py-1 rounded bg-slate-800 text-white">Enviar comentário</button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
